export class PortalSettings {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.workspaceId = model.workspaceId;
        this.enabledDesignSystemIds = model.enabledDesignSystemIds || [];
        this.enabledBrandPersistentIds = model.enabledBrandPersistentIds || [];
        this.theme = model.theme || undefined;
        this.sidebar = model.sidebar || undefined;
    }
}
